<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">
        <span *ngIf="modalData.assessmentType == 'ValueAssessment'">Value Assessment Report</span>
        <span *ngIf="modalData.assessmentType !== 'ValueAssessment'">Technical Assessment Report</span>
    </h4>
</div>

<div class="modal-body">
    <app-view-assessment-report
        [jobMatchId]="modalData.jobMatchId"
        [testInvitationId]="modalData.testInvitationId"
        [isSectionalReport]="modalData.isSectionalReport"
        [assessmentType]="modalData.assessmentType"
        [context]="modalData.context">
    </app-view-assessment-report>
</div>
